import { render } from "./Accordion.vue?vue&type=template&id=0702053f"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=0702053f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Accordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0702053f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0702053f', __exports__)) {
    api.reload('0702053f', __exports__)
  }
  
  module.hot.accept("./Accordion.vue?vue&type=template&id=0702053f", () => {
    api.rerender('0702053f', render)
  })

}


export default __exports__